import {Pipe, PipeTransform} from '@angular/core'

@Pipe({
  name: 'cftIsPdf',
  pure: true,
})
export class IsPdfPipe implements PipeTransform {
  transform(file: {contentType: string} | undefined): boolean {
    return !!file && file.contentType.includes('application/pdf')
  }
}
